import { formatCurrency } from "../NumberInput/CurrencyInput";
import { toCamelCase } from "../utils/string";

import { validatorRegistry } from "./validatorRegistry";

validatorRegistry.registerFormValidator(
  "SumListValidator",
  (subject, { options, fields }) => {
    const { limitPct } = options;
    const limitPath = toCamelCase(options?.limitPath);
    const listPath = toCamelCase(options?.listPath);
    const valuePath = toCamelCase(options?.valuePath);
    const limitId = fields.find((f) => f.storagePath == limitPath).id;
    const listId = fields.find((f) => f.storagePath == listPath).id;
    return subject.test("SumListValidator", function (values) {
      const limitValue = values[limitId];
      const summedValue = (values[listId] || []).reduce(
        (a, b) => a + Number(b[valuePath]),
        0
      );
      if (summedValue > limitValue * limitPct) {
        this.options.context.onTouched({ [limitId]: true });
        const requiredLimit = formatCurrency(summedValue * 4);
        const message = `Must be at least ${requiredLimit}`;
        return this.createError({ path: limitId, message });
      }
      return true;
    });
  }
);
